import { isbot } from 'isbot';
import { getUA } from 'react-device-detect';

const MOBILE_UA_REGEX = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;

const resolveUA = (ua?: string): string =>
  ua ?? (typeof navigator === 'undefined' ? '' : navigator.userAgent);

/**
 * Bot detection backed by `isbot` (covers Googlebot, Bingbot, link unfurlers,
 * headless Chrome, etc.). Use this to gate promo UI (smart banner, "Open in
 * app" modal) so it never leaks into Search Console rendered previews —
 * Googlebot's mobile UA contains "Android" and would otherwise pass a naive
 * mobile check.
 */
export const isBotUserAgent = (ua?: string): boolean => {
  const value = resolveUA(ua);
  return value ? isbot(value) : false;
};

/** Mobile UA check that explicitly excludes bots. */
export const isMobileUserAgent = (ua?: string): boolean => {
  const value = resolveUA(ua);
  if (!value) return false;
  if (isbot(value)) return false;
  return MOBILE_UA_REGEX.test(value);
};

/** Android vs. iOS/other, for picking a store/deep-link URL. */
export const isAndroidUserAgent = (ua?: string): boolean => {
  const value = resolveUA(ua);
  return /Android/i.test(value);
};

export const isFacebookApp = (): boolean => {
  return getUA.indexOf('FBAN') > -1 || getUA.indexOf('FBAV') > -1;
};

export const isInstagramApp = (): boolean => {
  return getUA.indexOf('Instagram') > -1;
};

export const isBuildInBrowser = (): boolean => {
  return isFacebookApp() || isInstagramApp();
};

export const isIOS15 = (): boolean => {
  return getUA.toLowerCase().includes('iphone os 15');
};
